import { Box, BoxProps } from "@mui/material"

interface LogoProps extends BoxProps{
    logoWidth?:string | number | undefined,
    logoHeight?:string | number | undefined
}

export default function Logo({
    logoWidth,
    logoHeight,
    ...props
}: LogoProps) {
    return <Box {...props}>
        <img width={logoWidth} height={logoHeight} src={"/logo.svg"}/>
    </Box>
}